export default __webpack_public_path__ + "static/media/BootsSharp-Bold1.58178a37.ttf";